import {
  MdButton,
  MdDialog,
  MdDialogActions,
  MdDialogContent
} from "@torre-labs/material";
import Vue from "vue";
import { mapState } from "vuex";

import { Message } from "@/components/opportunity-snackbar/Message";
import { NotificationsService } from "@/services";

export default Vue.extend({
  components: {
    MdButton,
    MdDialog,
    MdDialogActions,
    MdDialogContent
  },
  computed: {
    // Temporal fix until https://github.com/vuejs/vuex/pull/1121/files is approved.
    authentication: () => ({user: {}, id: "", ready: false}),
    user(): any {
      return this.authentication.ready ? this.authentication.user : undefined;
    },
    ...mapState("users", ["authentication"])
  },
  mounted(): void {
    this.$nextTick(() => {
      const notificationPreferences = this.$refs.notificationPreferences as MdDialog;
      notificationPreferences.open();
    });
  },
  methods: {
    closeCandidateDialog(): void {
      const notificationPreferences = this.$refs.notificationPreferences as MdDialog;
      notificationPreferences.close();

      this.$router.push({
        name: this.$route.name,
        params: this.$route.params,
        query: this.$route.query
      });
    },
    save(option: string) {
      if (this.user) {
        NotificationsService.add(this.$route.params.id, { status: option })
          .subscribe((result) => {
            this.closeCandidateDialog();
            this.$root.$emit("flash-message", new Message("Saved", 3000));
          }, (error) => {
            this.$root.$emit("flash-message", new Message("Error saving"));
          });
      }
    }
  }
});
